import { FileRejection } from 'react-dropzone';
// @mui
import { Alert, Stack, Box } from '@mui/material';
//
import { fileData } from '../file-thumbnail';

// ----------------------------------------------------------------------

type Props = {
  fileRejections: FileRejection[];
};

export default function RejectionFiles({ fileRejections }: Props) {
  if (!fileRejections.length) {
    return null;
  }
  const hasFileError = fileRejections.find((file) => file.errors?.find((x) => x.type));
  const filterRejections = hasFileError ? [{ ...hasFileError, errors: hasFileError?.errors?.filter?.((x) => x.type) }] : fileRejections;

  return (
    <Alert severity="error" sx={{ mt: 3 }}>
      <Stack gap={1}>
        {filterRejections.map(({ file, errors }) => {
          const { path } = fileData(file);

          return (
            <Box key={path}>
              {errors.map((error) => (
                <Box key={error.code} component="span" sx={{ typography: 'caption' }} id="file-error">
                  {error.message}
                </Box>
              ))}
            </Box>
          );
        })}
      </Stack>
    </Alert>
  );
}
